const cardItems = [
  {
    tag: '深度解读',
    title: '某知名互联网公司裁员风波：从内部信到舆论危机的72小时',
    desc: '一封内部全员信引发连锁反应，社交媒体讨论量突破千万。本文还原事件关键节点与各方反应。',
    image: 'https://readdy.ai/api/search-image?query=Modern%20office%20building%20at%20dusk%20with%20dramatic%20clouds%2C%20corporate%20theme%2C%20warm%20sunset%20light%20through%20glass%20windows%2C%20abstract%20corporate%20atmosphere%2C%20editorial%20photography%20style&width=600&height=420&seq=card-01-heiliao&orientation=landscape',
    date: '2026.07.27',
    reads: '89K',
  },
  {
    tag: '行业揭秘',
    title: '医美行业乱象调查：无证行医与虚假宣传背后的灰色产业链',
    desc: '暗访调查揭露多地医美机构存在资质造假、药品来源不明等严重问题，涉及金额巨大。',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20medical%20aesthetic%20clinic%20interior%20with%20dramatic%20lighting%2C%20white%20and%20chrome%20surfaces%2C%20mysterious%20atmosphere%2C%20healthcare%20investigation%20theme%2C%20warm%20and%20cold%20contrast%20lighting&width=600&height=420&seq=card-02-heiliao&orientation=landscape',
    date: '2026.07.26',
    reads: '76K',
  },
  {
    tag: '事件盘点',
    title: '2026年第二季度社交媒体争议事件TOP10全记录',
    desc: '从知名博主翻车到平台政策争议，盘点本季度最具话题性的十大社交媒体事件。',
    image: 'https://readdy.ai/api/search-image?query=Smartphone%20screen%20showing%20social%20media%20feed%20in%20dark%20environment%2C%20glowing%20screen%20reflection%2C%20digital%20communication%20theme%2C%20warm%20screen%20glow%20on%20dark%20background%2C%20modern%20tech%20aesthetic&width=600&height=420&seq=card-03-heiliao&orientation=landscape',
    date: '2026.07.24',
    reads: '134K',
  },
  {
    tag: '深度解读',
    title: '某电商平台"二选一"争议再起：商家集体发声背后的平台博弈',
    desc: '多位商家公开控诉平台强制排他性合作，引发反垄断讨论。事件折射出平台经济中的深层矛盾。',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20ecommerce%20warehouse%20with%20packages%20and%20shipping%20boxes%2C%20dramatic%20overhead%20lighting%2C%20logistics%20theme%2C%20warm%20industrial%20atmosphere%2C%20editorial%20documentary%20style&width=600&height=420&seq=card-04-heiliao&orientation=landscape',
    date: '2026.07.23',
    reads: '67K',
  },
  {
    tag: '事件解读',
    title: '学术造假风波再起：多位学者论文被撤稿事件深度追踪',
    desc: '国际期刊批量撤稿涉及多所高校研究人员，学术诚信问题再次成为公众关注焦点。',
    image: 'https://readdy.ai/api/search-image?query=Old%20library%20reading%20room%20with%20stacked%20books%20and%20academic%20journals%2C%20warm%20reading%20lamp%20light%2C%20scholarly%20atmosphere%2C%20dramatic%20shadows%2C%20knowledge%20and%20truth%20theme&width=600&height=420&seq=card-05-heiliao&orientation=landscape',
    date: '2026.07.21',
    reads: '58K',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            深度解读
          </h2>
          <p className="text-foreground-600 text-sm md:text-base">
            多角度剖析热门事件，拒绝碎片化信息
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {cardItems.slice(0, 3).map((item, idx) => (
            <article
              key={idx}
              className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/60 hover:border-primary-200 transition-all duration-200"
            >
              <div className="relative h-[200px] overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 rounded-full bg-primary-500/90 text-background-50 text-xs font-medium whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="p-5">
                <div className="flex items-center gap-3 text-xs text-foreground-500 mb-3">
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i>
                    阅读 {item.reads}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-calendar-line"></i>
                    {item.date}
                  </span>
                </div>
                <h3 className="font-heading text-base font-semibold text-foreground-900 mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2">
                  {item.desc}
                </p>
              </div>
            </article>
          ))}
        </div>

        <div className="mt-5 grid grid-cols-1 sm:grid-cols-2 gap-5">
          {cardItems.slice(3).map((item, idx) => (
            <article
              key={idx + 3}
              className="group flex flex-col sm:flex-row bg-background-50 rounded-xl overflow-hidden border border-background-200/60 hover:border-primary-200 transition-all duration-200"
            >
              <div className="relative sm:w-[200px] h-[180px] sm:h-auto flex-shrink-0 overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 rounded-full bg-primary-500/90 text-background-50 text-xs font-medium whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="p-5 flex flex-col justify-center">
                <div className="flex items-center gap-3 text-xs text-foreground-500 mb-2">
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i>
                    阅读 {item.reads}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-calendar-line"></i>
                    {item.date}
                  </span>
                </div>
                <h3 className="font-heading text-base font-semibold text-foreground-900 mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2">
                  {item.desc}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}